





































import {Component, Prop, Vue} from 'vue-property-decorator'
import Avatar from "@/components/lfs/NewStatistics/GeneralDashboard/common/Avatar.vue";
import ErrorFetchingData from "@/components/lfs/NewStatistics/GeneralDashboard/common/ErrorFetchingData.vue";

@Component({
  name: 'ActiveStandmansQuantity',
  components: {ErrorFetchingData, Avatar}
})

export default class ActiveStandmansQuantity extends Vue {
  @Prop({ type: Object, default: () => {} }) protected activeStandmans!: object
  @Prop({ type: Array, default: () => {} }) protected avatars!: object[]
  @Prop({ type: Boolean, default: false }) protected loading!: boolean
  @Prop({ type: Boolean, default: false }) protected error!: boolean

}
